import React, { useState } from 'react';
import './swot.scss';
import { IcoStar } from '../../../components';


// Palavras-chave que DEVEM ser destacadas (antes dos ":")
const HIGHLIGHT_KEYWORDS = [
  'Marca:', 'Producto:', 'Establecimiento:',
  'Produto:', 'Estabelecimento:',
  'Brand:', 'Product:', 'Establishment:',
  'Marcas:', 'Productos:', 'Establecimientos:',
  'Produtos:', 'Estabelecimentos:',
  'Brands:', 'Products:', 'Establishments:'
];




// Formata texto: quebra por vírgula e remove vírgulas
const formatText = (text) => {
  if (!text) return [];
  return text
    .split(',')
    .map(part => part.trim())
    .filter(part => part !== '');
};

const SwotContent = ({ data, componentNls, nls }) => {
  if (!data) return null;

  // Função para campos COM quebra por vírgula (padrão)
  const formatWithCommaBreak = (text) => {
    if (!text) return [];
    return text
      .split(',')
      .map(part => part.trim())
      .filter(part => part !== '');
  };

  // Função para 'indicadores': NÃO quebrar por vírgula
  const formatIndicadores = (items) => {
    if (!Array.isArray(items)) return [];
    return items
      .map(item => item.trim())
      .filter(item => item !== '');
  };

  const pilares = ['preco', 'produto', 'atendimento', 'loja'];
  const pilarContent = pilares
    .map(key => ({
      key,
      label: componentNls?.[key] || key.charAt(0).toUpperCase() + key.slice(1),
      lines: formatWithCommaBreak(data[key])
    }))
    .filter(item => item.lines.length > 0);

  const sections = [
    {
      key: 'satisfacaogeral',
      label: componentNls?.satisfacaogeral || 'Satisfação geral',
      lines: formatWithCommaBreak(data.satisfacaoGeral)
    },
    {
      key: 'insatisfacaogeral',
      label: componentNls?.insatisfacaogeral || 'Insatisfação geral',
      lines: formatWithCommaBreak(data.insatisfacaoGeral)
    },
    ...pilarContent,
    {
      key: 'indicadores',
      label: componentNls?.indicadores || 'Principais Assuntos',
      lines: formatIndicadores(data.indicadores) // ← SEM quebra por vírgula!
    }
  ].filter(section => section.lines.length > 0);

  if (sections.length === 0) {
    return (
      <p className="swot-no-content">
        {componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'Sem dados para exibir'}
      </p>
    );
  }

  return (
    <div className="box-swot-content">
      {sections.map(section => (
        <div key={section.key} className="box-swot-content-info">
          <h3>
  <IcoStar className="swot-section-icon" />
  {section.label}
</h3>
          {section.lines.map((line, idx) => {
            // Só aplica destaque se houver ":" e a parte antes for palavra reservada
            if (line.includes(':')) {
              const [beforeColon, afterColon] = line.split(/:(.+)/, 2);
              const keyword = beforeColon.trim();
              //console.log("Keyword extraída:", JSON.stringify(keyword));
              const description = afterColon?.trim() || '';
              const shouldHighlight = HIGHLIGHT_KEYWORDS.includes(keyword);

              //console.log("HIGHLIGHT_KEYWORDS",keyword);
              //console.log("HIGHLIGHT_KEYWORDS TRUE OR FALSE",shouldHighlight)


              return (
                <div key={idx} className="box-swot-content-info-list">
                  
                  {shouldHighlight ? (
                    <>
                      <span className="box-swot-content-info-list-loja">{keyword}</span>
                      <p>{description}</p>
                    </>
                  ) : (
                    <p>{line}</p>
                  )}
                </div>
              );
            } else {
              return (
                <div key={idx} className="box-swot-content-info-list">
                  
                  <p>{line}</p>
                </div>
              );
            }
          })}
        </div>
      ))}
    </div>
  );
};

export default function Swot({
  nls = {},
  componentNls = {},
  filtros = [],
  payloadData = {},
  totaldata
}) {

  console.log('Swot props', { nls, componentNls });
  console.log('Swot indicadores', {
    componentNlsIndicadores: componentNls?.indicadores,
    nlsIndicadores: nls?.indicadores
  });


  const [activeTab, setActiveTab] = useState('forca');

  const tabs = [
    { key: 'forca', label: componentNls?.forca || 'Força' },
    { key: 'fraqueza', label: componentNls?.fraqueza || 'Fraqueza' },
    { key: 'ameaca', label: componentNls?.ameaca || 'Ameaça' },
    { key: 'oportunidade', label: componentNls?.oportunidade || 'Oportunidade' }
  ];

  const hasAnyContent = tabs.some(tab => {
    const data = payloadData[tab.key];
    if (!data) return false;
    return (
      data.satisfacaoGeral ||
      data.insatisfacaoGeral ||
      (data.indicadores && data.indicadores.length > 0) ||
      ['preco', 'produto', 'atendimento', 'loja'].some(k => data[k])
    );
  });

  return (
    <>
    <section className="box-swot box-content-like">
      {/* Filtros */}
      {filtros.length > 0 && (
        <div className="feedback-filtros-aplicados">
          <p className="filtros-label">{nls?.filtrosAplicados || 'Filtros aplicados'}:</p>
          <ul className="filtros-lista">
            {filtros.map((filtro, idx) => (
              <li key={idx} className="filtro-item">
                <strong>{filtro.nomedofiltro}:</strong> {filtro.valordofiltro}
              </li>
            ))}
          </ul>
        </div>
      )}

      {!hasAnyContent ? (
        <div className="box-swot-mensagem">
          <p>{componentNls?.semdadosparaexibir || nls?.semdadosparaexibir || 'Sem dados para exibir'}</p>
        </div>
      ) : (
        <>
          <div className="swot-tabs">
            {tabs.map(tab => (
              <button
                key={tab.key}
                className={`swot-tab ${activeTab === tab.key ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="swot-tab-content">
            <SwotContent
              data={payloadData[activeTab]}
              componentNls={componentNls}
              nls={nls}
            />
          </div>
        </>
      )}
    </section>
    {totaldata !== null && totaldata !== undefined && (
      <div className="feedback-totaldata-outside">
        {nls?.numerodefeedbacks}: <strong>{totaldata}</strong>
      </div>
    )}
  </>
  );
}


/*
JSON INPUT

{
      "nls": {
        "forca": "Força",
        "preco": "Preço",
        "ameaca": "Ameaça",
        "produto": "Produto",
        "fraqueza": "Fraqueza",
        "atendimento": "Atendimento",
        "indicadores": "Principais Assuntos",
        "oportunidade": "Oportunidade",
        "estabelecimento": "Estabelecimento",
        "satisfacaogeral": "Satisfação geral",
        "insatisfacaogeral": "Insatisfação geral",
        "semdadosparaexibir": "No data"
      },
      "label": "Análise Swot",
      "scope": {
        "periodo": {
          "fim": "2025-10-06",
          "ini": "2025-08-01"
        },
        "projetoId": 47,
        "sobreSegmento": "estabelecimentos"  //aqui precisa ter estabelecimentos ou produtos ou servicos
      },
      "params": {
        "idiomaId": 2,
        "empresaId": 235,
        "grupoLojaId": 33   //aqui precisa ter grupoLojaId, grupoProdutoId ou não existir
      },
      "Filtros": [
        {
          "nomedofiltro": "Empresa",
          "valordofiltro": "Assaí"
        },
        {
          "nomedofiltro": "Grupo",
          "valordofiltro": "Cobertura Nacional"
        }
      ],
      "ordinal": 7,
      "topicKey": "swot"
    }


EXEMPLO DE SWOT DE PRODUTO

{
      "nls": {
        "forca": "Força",
        "preco": "Preço",
        "ameaca": "Ameaça",
        "produto": "Produto",
        "fraqueza": "Fraqueza",
        "atendimento": "Atendimento",
        "indicadores": "Principais Assuntos",
        "oportunidade": "Oportunidade",
        "estabelecimento": "Estabelecimento",
        "satisfacaogeral": "Satisfação geral",
        "insatisfacaogeral": "Insatisfação geral",
        "semdadosparaexibir": "No data"
      },
      "label": "Análise Swot",
      "scope": {
        "periodo": {
          "fim": "2025-08-31",
          "ini": "2025-08-01"
        },
        "projetoId": 24,
        "sobreSegmento": "produtos"  //estabelecimentos ou servicos
      },
      "params": {
        "idiomaId": 2,
        "empresaId": 138,
        "grupoProdutoId": 3  //grupoLojaId ou não existe(se sobreSegmento = servicos)
      },
      "Filtros": [
        {
          "nomedofiltro": "produto",
          "valordofiltro": "Apple"
        },
        {
          "nomedofiltro": "Grupo",
          "valordofiltro": "celular"
        }
      ],
      "ordinal": 7,
      "topicKey": "swot"
    }



*/
